import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import classnames from 'classnames';
import { useHistory } from 'react-router-dom';
import { virtualPageView } from '../../googleTagManager';
import { entertainmentDetailsPage, schedulePage } from '../../utils';
import './Entertainment.scss';
import EntertainmentCategory from '../entertainmentCategory/EntertainmentCategory';

const Entertainment = ({
  title = '',
  subTitle = '',
  entertainments,
  resId = 0,
  siteCode = '',
  getAvailableEntertainments = () => { },
  shouldFetchBookedEntertainments = false,
  getBookedEntertainments = () => { },
  shouldFetchAvailableEntertainments,
  shouldSkip = false,
  bookedEvents = [],
  detailPage = entertainmentDetailsPage,
  isSummaryPage = false,
  isAllowedToBookEntertainment,
  shouldFetchBackstopDate,
  getBackstopDateFromApi,
}) => {
  const history = useHistory();

  useEffect(() => {
    virtualPageView('plan my day', 'book entertainment', '/ga-virtual/plan-my-day/book-entertainment');
  }, []);

  useEffect(() => {
    if (shouldFetchAvailableEntertainments) getAvailableEntertainments(siteCode);
  }, [
    shouldFetchAvailableEntertainments,
    getAvailableEntertainments,
    siteCode,
  ]);

  useEffect(() => {
    if (shouldFetchBookedEntertainments) getBookedEntertainments(resId, siteCode);
  }, [
    resId,
    siteCode,
    shouldFetchBookedEntertainments,
    getBookedEntertainments,
  ]);

  useEffect(() => {
    if (shouldSkip && !isSummaryPage) history.push(schedulePage);
  }, [shouldSkip, isSummaryPage, history]);

  useEffect(() => {
    if (shouldFetchBackstopDate) getBackstopDateFromApi();
  }, [shouldFetchBackstopDate, getBackstopDateFromApi]);

  if (shouldSkip && isSummaryPage) return null;
  if (!isAllowedToBookEntertainment && isSummaryPage) return null;

  return (
    <div>
      <div className={classnames('entertainment-main-container', !isSummaryPage && 'notSummaryPage')}>
        <div className="titles">
          <div className="title">{!isSummaryPage ? title : ''}</div>
          <div className="sub-title">{subTitle}</div>
        </div>
        <div className={classnames('entertainments', !isSummaryPage && 'notSummaryPage')}>
          {entertainments.filter(({ events }) => events && events.length > 0).map(({ date, events }, index) => (
            <EntertainmentCategory
              key={index}
              categoryIndex={index}
              date={date}
              events={events}
              bookedEvents={bookedEvents}
              detailPage={detailPage}
            />
          ))}
        </div>
      </div>
    </div>

  );
};

Entertainment.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  entertainments: PropTypes.array,
  resId: PropTypes.number,
  siteCode: PropTypes.string,
  getAvailableEntertainments: PropTypes.func,
  shouldFetchBookedEntertainments: PropTypes.bool,
  getBookedEntertainments: PropTypes.func,
  shouldFetchAvailableEntertainments: PropTypes.bool,
  shouldSkip: PropTypes.bool,
  bookedEvents: PropTypes.array,
  detailPage: PropTypes.string,
  isSummaryPage: PropTypes.bool,
  isAllowedToBookEntertainment: PropTypes.bool,
  shouldFetchBackstopDate: PropTypes.bool,
  getBackstopDateFromApi: PropTypes.func,
};

export default Entertainment;
